import axios from 'axios'
import { authHeader } from './auth-header'
import router from '@/router'

class AppApi {
    config = {
      authHeader: true,
      baseURL: process.env.VUE_APP_BASE_URL,
      redirectToLogin: true,
      contentType: 'application/json',
    }

    getAxios (cfg) {
      return new Promise((resolve, reject) => {
        function createInstance () {
          const axiosInstance = axios.create({
            headers,
          })
          if (cfg.redirectToLogin) {
            axiosInstance.interceptors.response.use((response) => {
              // Return a successful response back to the calling service
              return response
            }, (error) => {
              // Return any error which is not due to authentication back to the calling service
              if (error.response.status === 401) {
                router.push({ name: 'login' })
                return new Promise((resolve, reject) => {
                  reject(error)
                })
              }
            })
          }
          return axiosInstance
        }
        const headers = {
          'Content-Type': cfg.contentType,
        }

        if (cfg.authHeader) {
          authHeader().then(ah => {
            Object.assign(headers, ah)
            const axiosInstance = createInstance()
            resolve(axiosInstance)
          }).catch(err => {
            if (cfg.redirectToLogin) { router.push({ name: 'Login' }) }
            reject(err)
          })
        } else {
          const axiosInstance = createInstance()
          resolve(axiosInstance)
        }
      })
    }

    post (url, data, cfg) {
      return new Promise((resolve, reject) => {
        const cfgTarget = JSON.parse(JSON.stringify(this.config))
        if (cfg) {
          Object.assign(cfgTarget, cfg)
        }
        this.getAxios(cfgTarget).then(ax => {
          data = this.prepareData(data, cfgTarget.contentType)
          ax.post(cfgTarget.baseURL + url, data)
            .then(response => {
              var rd = response.data
              if (rd == null) {
                const ex = {
                  success: false,
                  message: 'Response is undefined',
                  messageType: 'error',
                }
                throw ex
              } else {
                if (rd.success === false) {
                  throw rd
                } else {
                  resolve(rd.data)
                }
              }
            })
            .catch(error => {
              const ex = {
                title: '',
                success: false,
                message: error.message,
                messageType: 'error',
                exception: error,
              }

              reject(ex)
            })
        }).catch(error => {
          console.log('getAxios instance error')
          const ex = {
            title: '',
            success: false,
            message: error.message,
            messageType: 'error',
            exception: error,
          }

          reject(ex)
        })
      })
    }

    get (url, data, cfg) {
      return new Promise((resolve, reject) => {
        const cfgTarget = JSON.parse(JSON.stringify(this.config))
        if (cfg) {
          Object.assign(cfgTarget, cfg)
        }
        this.getAxios(cfgTarget).then(ax => {
          data = this.prepareData(data, cfgTarget.contentType)
          ax.get(cfgTarget.baseURL + url, data)
            .then(response => {
              var rd = response.data
              if (rd == null) {
                const ex = {
                  success: false,
                  message: 'Response is undefined',
                  messageType: 'error',
                }
                throw ex
              } else {
                if (rd.success === false) {
                  throw rd
                } else {
                  resolve(rd.data)
                }
              }
            })
            .catch(error => {
              const ex = {
                title: '',
                success: false,
                message: error.message,
                messageType: 'error',
                exception: error,
              }
              reject(ex)
            })
        }).catch(error => {
          console.log('getAxios instance error')
          const ex = {
            title: '',
            success: false,
            message: error.message,
            messageType: 'error',
            exception: error,
          }

          reject(ex)
        })
      })
    }

    prepareData (data, contentType) {
      if (contentType.indexOf('json') !== -1 || contentType.indexOf('multipart') !== -1) { return data }
      if (contentType.indexOf('urlencoded') !== -1) {
        const pairs = []
        for (const [key, value] of Object.entries(data)) {
          pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        }
        return pairs.join('&')
      }
    }
}

export default new AppApi()
